import axios from 'axios'

const getUrlParams = function () {
  const params = {}
  window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
    params[key] = value
  })
  return params
}

// 기존 API (cmd/func 구조)
const LEGACY_BASE_URL =
  getUrlParams().debug && getUrlParams().debug === '1'
    ? process.env.VUE_APP_API_URL_DEV
    : process.env.VUE_APP_API_URL_ORGIN

export const legacyClient = axios.create({
  baseURL: LEGACY_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

// 신규 API
const NEW_BASE_URL =
  getUrlParams().debug && getUrlParams().debug === '1'
    ? process.env.VUE_APP_API_URL_NEW_DEV
    : process.env.VUE_APP_API_URL_NEW_PROD

export const client = axios.create({
  baseURL: NEW_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

// 이미지 업로드 전용 (Content-Type: application/octet-stream)
export const imageClient = axios.create({
  baseURL: NEW_BASE_URL,
  headers: { 'Content-Type': 'application/octet-stream' }
})
